/* eslint-disable @repo/internal/react/no-css-string-literals */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { ButtonGroup } from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

const stopPropagation = (event: React.MouseEvent) => event.stopPropagation();

/**
 * __Example action container__.
 *
 * An example action container sits at the top right of an example container and displays various actions for the user.
 *
 */
export const ExampleActionContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    /**
     * This element uses an `onMouseDown` to block event propagation
     * to its parent but is not itself interactive.
     */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    <div
      css={css`
        position: absolute;
        top: 0;
        right: 0;
        padding: ${token('space.050', '4px')};

        z-index: 1;
      `}
      // Stops the code expanding when you click an action
      onMouseDown={stopPropagation}
    >
      <ButtonGroup label="Example actions">{children}</ButtonGroup>
    </div>
    /* eslint-enable jsx-a11y/no-static-element-interactions */
  );
};
